import React, { useEffect } from 'react';
import PageContainer from './containers/PageContainer/PageContainer';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import Strings from 'localization/Strings';
import { Version } from './Version';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  useEffect(() => {
    console.log('App version:', Version);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<PageContainer isBriefMode={false} />} />
      <Route path="/:lang" element={<LocalizedHome />} />
      <Route path="/:lang/brief" element={<LocalizedHomeBriefMode />} />
    </Routes>
  );
}

function LocalizedHome() {
  const { lang } = useParams();
  Strings.setLanguage(lang);

  // You can use this `lang` to load translations or redirect
  return <PageContainer isBriefMode={false} lang={lang} />;
}

function LocalizedHomeBriefMode() {
  const { lang } = useParams();
  Strings.setLanguage(lang);

  // Skip welcome page and start from Age question
  return <PageContainer isBriefMode={true} lang={lang} />;
}

export default App;
